import { render, staticRenderFns } from "./view-person.vue?vue&type=template&id=d0249bbc&scoped=true"
import script from "./view-person.vue?vue&type=script&lang=js"
export * from "./view-person.vue?vue&type=script&lang=js"
import style0 from "./view-person.vue?vue&type=style&index=0&id=d0249bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0249bbc",
  null
  
)

export default component.exports